import { getToken } from "../../../shared/utils/common";

export class CommandUpdateLayer {
  async run(layerId: number, formData: FormData) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/layers/${layerId}/`;
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: { Authorization: `Token ${getToken()} ` },
        body: formData,
      })
        .then((response) => response.json())
        .then((json) => json)
        .catch((err) => console.log(err));
      if (response) {
        return response;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

}
